import { useToggleTypes } from 'hooks';

export default (editor) => {
  const cmd = editor.Commands;

  cmd.add('personal-notes', {
    run(editor) {
      const model = editor.getModel();

      const onShow = model.get('onShow');

      onShow(useToggleTypes.showPersonalNotesModal);
    },
  });
};
